import * as yup from 'yup';


export const commonDocumentEnquiryValidation: { [x: string]: any; } = {
  invPrinter: yup.string().required("Missing."),
  suppPrinter: yup.string().required("Missing."),
};
export const InvDocumentEnquiryValidation: { [x: string]: any; } = {
  invPrinter: yup.string().required("Missing."),
};

export const createDocumentEnquiryValidation: { [x: string]: any; } = {
  ...commonDocumentEnquiryValidation,
};
export const createInvDocumentEnquiryValidation: { [x: string]: any; } = {
  ...InvDocumentEnquiryValidation,
};

export const createDocumentEnquiryValidationSchema = yup.object().shape(createDocumentEnquiryValidation);
export const createInvDocumentEnquiryValidationSchema = yup.object().shape(createInvDocumentEnquiryValidation);

